import React, { useState } from 'react';
import { useLang } from '../../core/lang';
import LangKeys from '../../core/locales/keys';
import { X, Check } from 'lucide-react';

const TermsConditionsModal = ({ isOpen, onClose, initialText, onSave }) => {
  const { t } = useLang();
  const [text, setText] = useState(initialText || "");

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
           <h3 style={styles.title}>{t(LangKeys.add_bill_terms_conditions)}</h3>
           <button style={styles.closeBtn} onClick={onClose}><X size={20} /></button>
        </div>
        
        <div style={styles.content}>
           <textarea 
             style={styles.textarea} 
             value={text} 
             onChange={(e) => setText(e.target.value)} 
             placeholder={t(LangKeys.add_bill_terms_conditions_hint || 'Enter your terms and conditions here...')}
           />
           <p style={styles.hint}>{t(LangKeys.add_bill_printed_on_invoice)}</p>
        </div>

        <div style={styles.footer}>
           <button style={styles.saveBtn} onClick={() => onSave(text)}>
              <Check size={18} /> <span>SAVE TERMS</span>
           </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 },
  modal: { width: '100%', maxWidth: '500px', background: 'white', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' },
  header: { padding: '20px 24px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontSize: '18px', fontWeight: '800', color: '#0F172A', margin: 0 },
  closeBtn: { border: 'none', background: 'transparent', cursor: 'pointer', color: '#94A3B8' },
  content: { padding: '24px', display: 'flex', flexDirection: 'column', gap: '12px' },
  textarea: { width: '100%', height: '200px', padding: '16px', borderRadius: '12px', border: '1px solid #E2E8F0', background: '#F8FAFC', fontSize: '14px', fontWeight: '600', outline: 'none', resize: 'none', fontFamily: 'inherit' },
  hint: { fontSize: '11px', color: '#94A3B8', fontWeight: '700', textTransform: 'uppercase', margin: 0 },
  footer: { padding: '16px 24px', background: '#F8FAFC', borderTop: '1px solid #F1F5F9' },
  saveBtn: { width: '100%', height: '48px', borderRadius: '12px', border: 'none', background: '#1D4ED8', color: 'white', fontWeight: '800', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', cursor: 'pointer' }
};

export default TermsConditionsModal;
